<script>
export default {
  props: {
    image: {
      type: String,
      default: process.env.VUE_APP_MODE === 'dingbeauty' ? require('@assets/images/dingbeauty/reservation/no-record.svg') : require('@assets/images/reservation/no-record.svg')
    },
    title: {
      type: String,
      default: ''
    },
    imageClass: {
      type: String,
      default: ''
    },
    titleClass: {
      type: String,
      default: ''
    }
  },
}
</script>
<!-- section template -->
<template>
  <div :class="$style.baseNull">
    <img
      alt=""
      :src="image"
      class="baseNull__img"
      :class="imageClass"
    >
    <div
      v-if="title"
      class="baseNull__title"
      :class="titleClass"
      v-html="title"
    ></div>
    <slot/>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.baseNull {
  width: 100%;
  padding: 100px 0;
  text-align: center;

  :global {
    .baseNull {
      &__img {
        margin: 0 auto 2.5rem;
      }

      &__title {
        color: $color-gray-2;
        letter-spacing: 0.25em;
      }
    }
  }
}
</style>
